export const DEFAULT_GOAL_DISPLAY_NAMES = {
  goalName: 'Objectives',
  keyResultName: 'Key Results',
} as const;

export type GoalDisplayNameField = keyof typeof DEFAULT_GOAL_DISPLAY_NAMES;

export const normalizeDisplayName = (value?: string | null) =>
  value?.trim() || '';

export const isDisplayNameDirty = (draftValue: string, savedValue: string) =>
  normalizeDisplayName(draftValue) !== normalizeDisplayName(savedValue);

export const canMembersEditGoals = (value?: string | null) =>
  Boolean(value && value !== 'never');

export const memberGoalEditValue = (enabled: boolean) =>
  enabled ? 'forever' : 'never';
